<template>
    <div class="biz-house-card-m">
        <modal class="delete-house" :display="modalStatus.deleteHouse" @modalStatus="closeModal('deleteHouse')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除房源</h1>
            <div class="content">
                確定刪除“{{house?house.houseName:'房源名稱'}}”的房源嗎？<br>記錄刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteHouse(house.cid)">確認</button>
                <button class="border-button" @click="closeModal('deleteHouse')">取消</button>
            </div>
        </modal>
        <modal class="alarm-orange" :display="modalStatus.editHouse" @modalStatus="closeModal('editHouse')" >
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_orange.svg" alt="">
            <h1>無法上架</h1>
            <div class="content">
                目前有進行中的合約，請先更新最快起租日
            </div>
            <div class="btn-group">
                <button class="default-button" @click="toEditPage()">編輯房源</button>
            </div>
        </modal>
        <div v-if="house" class="biz-house-card" :class="{'rented': !house.empty}" :data-id="house.cid" @click="clickEvent"  @mouseenter="changeAddressIcon" @mouseleave="changeAddressIcon">
            <div class="house-card-wrap">
                <img class="video-icon" v-if="house.hasFilm" src="@/assets/img/icon/film.svg" alt="" srcset="">
                <div class="house-view-count h-align">
                    <img src="@/assets/img/icon/views.svg" title="點閱次數">
                    {{house.houseViewCount}}
                    <span class="tips">點閱次數</span>
                </div>
                <div v-if="house.coverImage" class="house-image">
                    <img :src="imageUrl(house.coverImage)" alt="">
                </div>
                <div v-else class="house-image">
                    <img src="@/assets/img/component/houseCard/default.svg" alt="">
                </div>
                <div class="content-wrap">
                    <div class="house-card-title" :class="{'title-gray': house.houseName == '未完善房源' || house.houseName == '紙本合約' }">
                        {{house.houseName}}
                    </div>
                    <div class="house-card-address">
                        {{house.address}}
                        <img id="address-icon" :src="addressIcon" alt="">
                    </div>
                    <div class="house-card-price" v-if="price">
                        ${{price}}
                    </div>
                    <div class="house-state">
                        <!-- 1上架
                        2預定中
                        3已租
                        4下架 -->
                        <span v-if="house.goodHouse" class="goodHouse">
                            <img src="@/assets/img/icon/good_house.svg" alt="">
                        </span>
                        <span v-if="house.publish" class="put">上架</span>
                        <span v-else class="off">下架</span>
                        <span v-if="house.complete" class="completed">完善</span>
                        <span v-else class="uncompleted">未完善</span>
                        <dot-dropmenu>
                            <ul>
                                <li v-if="bizAuth.onOrOffShelf.hasRight && house.complete && !house.publish" @click="setBizHousePublish({houseCid: house.cid, status:'REVEAL'})">上架</li>
                                <li v-if="bizAuth.onOrOffShelf.hasRight && house.publish" @click="setBizHousePublish({houseCid: house.cid, status:'HIDE'})">下架</li>
                                <li v-if="bizAuth.shareHouse.hasRight && house.complete && house.publish" @click="shareHouse(house.cid)">分享</li>
                                <li v-if="bizAuth.previewHouse.hasRight && house.complete" @click="previewHouse(house.cid)">預覽</li>
                                <li v-if="bizAuth.deleteHouse.hasRight" @click="openModal('deleteHouse')">刪除</li>
                                <!-- <li>檢舉平反(待確認)</li>
                                <li>更新時間(待確認)</li>
                                <li>複製廣告(待確認)</li> -->
                            </ul>
                        </dot-dropmenu> 
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="biz-house-card loading">
            <div class="house-card-wrap">
                <div class="house-state">
                    <span></span>
                </div>
                <img class="house-image" src="@/assets/img/component/houseCard/default.svg" alt="">
                <div class="content-wrap">
                    <div class="house-card-title">
                    </div>
                    <div class="house-card-address">
                    </div>
                    <div class="house-card-price">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import constant from '@/constant'
import { mapGetters } from 'vuex'
import { 
    apiBizPublishHouse
} from "@/apis/api.js"; 


export default {
    name: 'HouseCard',
    data () {
        return {
            addressIcon: require('@/assets/img/icon/address_green_border.svg'),
            modalStatus:{
                deleteHouse: false,
                editHouse: false
            },
        }
    },
    props:{
        house: ''
    },
    methods: {
        toEditPage: function () {
            this.$router.push({name: 'bizEditHouse', query: {'cid': this.house.cid}})
            this.closeModal('editHouse')
        },
        setBizHousePublish: function (data) {
            if(data.status === 'REVEAL' && !this.house.publishAvailable){
                this.openModal('editHouse')
                return false
            }
            
            apiBizPublishHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('getBizHouseMgtList')
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})

                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        openModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', true)
            if(type == 'deleteHouse'){
                if(this.house.arrears){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '當房源有欠款時，不得刪除',type: 'error', closeBtn: true})
                }else{
                    this.modalStatus.deleteHouse = true
                }
            }else if(type == 'editHouse'){
                this.modalStatus.editHouse = true
            }
        },
        closeModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', false)
            if(type == 'deleteHouse'){
                this.modalStatus.deleteHouse = false
            }else if(type == 'editHouse'){
                this.modalStatus.editHouse = false
            }
        },
        shareHouse: function (houseCid) {
            this.$analyticsBiz.logEvent('分享房源', { screen_name: '分享房源'})
            this.$store.commit('bizHouseManagement/set_selected_house_cid', houseCid)
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizShareSocialMedia'})
        },
        previewHouse: function (houseCid) {
            this.$analyticsBiz.logEvent('預覽房源', { screen_name: '預覽房源'})
            let routeData = this.$router.resolve({name: 'previewHouse', query: {cid: houseCid, mode: 'preview'}});
            window.open(routeData.href, '_blank');
        },
        deleteHouse: function (houseCid) {
            this.$analyticsBiz.logEvent('刪除房源', { screen_name: '刪除房源'})
            this.$store.dispatch('deleteBizEditHouse', houseCid)
            .then( () => {
                this.closeModal('deleteHouse')
                this.$store.dispatch('getBizHouseMgtList')
            });
        },
        changeAddressIcon: function () {
            // console.log(event.target.id  == 'address-icon' )
            // console.log(event.type)
            if( event.type == 'mouseenter' ){
                this.addressIcon = require('@/assets/img/icon/address_pink.svg')
            }else if( event.type == 'mouseleave' ){
                this.addressIcon = require('@/assets/img/icon/address_green_border.svg')
            }
            // if( event.type == 'mouseenter' ){
            //     if( event.target.id  == 'address-icon' ){
            //         this.addressIcon = require('@/assets/img/icon/address_pink.svg')
            //     }else{
            //         this.addressIcon = require('@/assets/img/icon/address_green_border.svg')
            //     }
            // }else{
            //     if( event.target.id  == 'address-icon' ){
            //         this.addressIcon = require('@/assets/img/icon/address_pink.svg')
            //     }else{
            //         this.addressIcon = require('@/assets/img/icon/address_green_border.svg')
            //     }
            // }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        clickEvent: function (){
            // 權限導頁
            if(this.bizAuth.editHouse.hasRight){
                // 編輯權限
                if(this.house.locked){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '預定中不可編輯',type: 'error', closeBtn: true})
                }else{
                    this.$analyticsBiz.logEvent('編輯房源', { screen_name: '編輯房源'})
                    this.$router.push({name: 'bizEditHouse', query: {'cid': this.house.cid}})
                }
            }else{
                this.$analyticsBiz.logEvent('查看房源', { screen_name: '查看房源'})
                // 查看權限
                this.$router.push({name: 'bizViewHouse', query: {'cid': this.house.cid}})
            }
        },
        imageUrl: function (url){
            return constant.imageUrl+url
        }
    },
    computed: {
        price: function () {
            return this.toCurrency(this.house.rentPrice)
        },
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal
    }
}
</script>
<style lang="scss" scoped>
    .biz-house-card-m{
        #modal.delete-house{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        .biz-house-card{
            position: relative;
            width: 560px;
            // height: 95px;
            background: #fff;
            border-radius: 10px;
            border: solid 1px #f3f3f3;
            padding: 20px;
            box-sizing: border-box;
            cursor: pointer;
            
            .house-card-wrap{
                display: flex;
                align-items: center;
                .video-icon{
                    position: absolute;
                    bottom: 24px;
                    left: 24px;
                }
                .title-gray{
                    color: #a8a5a4;
                }
                .house-state{
                    position: absolute;
                    display: flex;
                    align-items: center;
                    right: 20px;
                    bottom: 16px;
                    .dot-drop-menu{
                        margin-left: 10px;
                    }
                    >span{
                        width: 52px;
                        height: 26px;
                        color: #fff;
                        font-size: 12px;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    >span.goodHouse{
                        margin-right: 12px;
                    }
                    >span.put{
                        background-color: rgba(113, 170, 229, 0.1);
                        color: #71aae5;
                        margin-right: 8px;
                    }
                    >span.off{
                        background-color: #f3f3f3;
                        color: #676362;
                        margin-right: 8px;
                    }
                    >span.completed{
                        background-color: #71aae5;
                    }
                    >span.uncompleted{
                        background-color: #ff9275;
                    }
                }
                .house-view-count{
                    position: absolute;
                    right: 20px;
                    top: 16px;
                    >img{
                        margin-right: 4px;
                    }
                    &:hover {
                        .tips{
                            display: flex;
                        }
                    }
                    .tips{
                        position: absolute;
                        display: none;
                        align-items: center;
                        justify-content: center;
                        width: 60px;
                        top: 50%;
                        right: -15px;
                        transform: translateY(15px);
                        padding: 4px 5px 4px;
                        border-radius: 4px;
                        background-color: #676362;
                        font-size: 12px;
                        line-height: 1.2;
                        color: #ffffff;
                        text-align: center;
                    }
                }
                .house-image{
                    width: 120px;
                    height: 95px;
                    border-radius: 4px;
                    margin-right: 16px;
                    display: flex;
                    align-items: center;
                    border-radius: 4px;
                    overflow: hidden;
                    >img{
                        width: 100%;
                    }
                }
                .content-wrap{
                    .house-card-title{
                        width: 329px;
                        font-size: 20px;
                        margin-bottom: 8px;
                    }
                    .house-card-address{
                        display: flex;
                        align-items: center;
                        font-weight: 300;
                        margin-bottom: 8px;
                        #address-icon{
                            margin-left: 4px;
                            cursor: pointer;
                        }
                    }
                    .house-card-price{
                        font-size: 16px;
                        font-weight: 500;
                    }
                }
            }
            
        }
        .house-card.loading{
            .house-card-wrap{
                .house-state{
                    animation-name: loading;
                        animation-duration: 3s;
                        animation-iteration-count: infinite;
                    width: 52px;
                    height: 26px;
                    border-radius: 2px;
                    background-color: #f0f0f0;
                }
                .content-wrap{
                    .house-card-title,
                    .house-card-address,
                    .house-card-price{
                        animation-name: loading;
                        animation-duration: 3s;
                        animation-iteration-count: infinite;
                        width: 277px;
                        height: 16px;
                        border-radius: 2px;
                        background-color: #f0f0f0;
                    }
                    .house-card-price{
                        width: 139px;
                    }
                }
            }
            
        }
        .house-card.loading:hover{
            background: #fff;
            border: solid 1px #d5dad8;
            .house-card-wrap{
                .house-state{
                    background-color: #f0f0f0;
                }
            }
        }
        .house-card:hover{
            box-shadow: 2px 2px 8px 0 rgba(41, 38, 37, 0.08);
        }
        @keyframes loading {
            0%   {opacity: 1;}
            50%  {opacity: 0.3;}
            100% {opacity: 1;}
        }
        // @media screen and (max-width: 1280px) {
        //     .house-card{
        //         width: 516px;
        //     }
        // }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/houseMgt/graphMode/HouseCard.vue